export default __webpack_public_path__ + "static/media/legend_seabed_sediments.731c6833.png";